const itemsPerPage = 24;

export {
  itemsPerPage,
};

export default itemsPerPage;
